module["exports"] = [
  "GmbH",
  "AG",
  "Gruppe",
  "KG",
  "GmbH & Co. KG",
  "UG",
  "OHG"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/company/suffix.js
 ** module id = 335
 ** module chunks = 0
 **/